import { Box, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { FONTS, SPACES } from 'src/constants'
import useStyles from './styles'

export interface IMenuItem {
  title: string
  isActive?: boolean
  tab?: string
}

interface IMenuItemComponent extends IMenuItem {
  handleChoose: () => void
}

interface IMenuItemsComponent {
  items: IMenuItem[]
  handleChooseItem: (currentItem: IMenuItem) => void
}

const MenuItem = ({ title, isActive = false, handleChoose }: IMenuItemComponent) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Box className={`${classes.itemContainer} `} style={{ position: 'relative' }}>
      <button type="button" className={classes.button} onClick={handleChoose}>
        <Typography
          fontWeight={FONTS.WEIGHTS.bold}
          fontSize={'1.125rem'}
          mb={SPACES.s}
          color={theme.palette.custom.darkBlue2}
        >
          {title}
        </Typography>
      </button>
      {isActive && (
        <Grid container style={{ position: 'absolute', left: 0, bottom: -6, zIndex: 10 }}>
          <Grid
            item
            sx={{
              backgroundColor: theme.palette.custom.primary,
            }}
            width={'100%'}
            height={'6px'}
          ></Grid>
        </Grid>
      )}
    </Box>
  )
}

const ItemsMenu = ({ items, handleChooseItem }: IMenuItemsComponent) => {
  const [t] = useTranslation()
  const classes = useStyles()
  return (
    <>
      <Grid container className={classes.container}>
        {items.map((item) => (
          <MenuItem
            key={item.title}
            title={t(item.title)}
            isActive={item.isActive}
            tab={item.tab}
            handleChoose={() => handleChooseItem(item)}
          />
        ))}
      </Grid>
    </>
  )
}

export { ItemsMenu }
